import React, { useEffect } from 'react';
import ReactGA from 'react-ga4'
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';


import fondo from '../../assets/img/landingPage/fondo.png';
import Expositor01 from '../../assets/img/landingPage/webinars/Raul.png';
import Expositor02 from '../../assets/img/landingPage/webinars/Lucia.png';
import LinkedIn from '../../assets/img/landingPage/webinars/icono-in.svg';

import Webinar01 from '../../assets/img/landingPage/webinars/Webinar-01@2x.png';

import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'

import user from '../../assets/img/ui_icons/Icon fa-regular-user.svg'

import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

const WebinarTimeToShare = () => {

    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-MQZQJN7TQL');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Framework Commander Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);


    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-webinar bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Encabezado */}
                <section className="w-100 webinarHeader text-center noGradient">
                    <span className="fl-label-2">NOV 20, 2025</span>
                    <p className="fl-subtitle-blue pb-5">SPANISH - TIME TBC</p>
                    <h1 className="fl-title-big m-0 pb-0 fl-txt-container-s">Time to Share: AVAP Solution</h1>
                    {/*<h2 className="fl-txt-container-s fl-title gradient-text mb-3">
                       Your gateway to the API-Driven Ecosystem
                    </h2>*/}
            
                    <p className="fl-txt-container-s fl-text-m pb-4">
                        Discover how AVAP’s AI-powered platform helps you design, manage, and scale APIs effortlessly, enabling automation, integration, and digital transformation across industries with security, speed, and composable flexibility.
                    </p>

                    {/*Boton Register*/}  
                    
                        <a className="glowBtn-hz disabled" 
                        style={{zIndex: 2}} 
                        href="#" 
                        target='#'>
                            <span className="btnInner"> Coming Soon</span>
                        </a>  
                </section>

                <section className='container pb-8 pt-8'>
                <div className="row">
                
                 
                        {/* Columna 1 vacía */}
                        {/*<div className="col-3"></div>*/}

                        {/* Expositor 1 con contenido */}
                        {/*<div className="col-md-3 col-sm-12 d-flex flex-column align-items-center">
                            <img src={Expositor01} alt="Imagen 1" className="fl-img-webinar mb-4"/>
                            <h3 className="h5">Raúl Nogales</h3>
                            <p className="text-muted">Founder & CEO, 101OBEX</p>
                            <a href="https://www.linkedin.com/in/raulnogales" target="_blank" rel="noopener noreferrer" className="mt-auto">
                            <img src={LinkedIn} alt="LinkedIn Icon" style={{ width: '18px', height: '18px' }} />
                        </a> 
                        </div>*/}

                        {/* 1 Expositor */}
                        <div className="col-12 d-flex flex-column align-items-center">
                            <img src={Expositor01} alt="Raúl Nogales" className="fl-img-webinar mb-4"/>
                            <h3 className="h5">Raúl Nogales</h3>
                            <p className="text-muted">Founder & CEO, 101OBEX</p>
                            <a href="https://www.linkedin.com/in/raulnogales" target="_blank" rel="noopener noreferrer" className="mt-auto">
                                <img src={LinkedIn} alt="LinkedIn Icon" style={{ width: '18px', height: '18px' }} />
                            </a> 
                        </div>

                        {/* Columna 4 vacía */}
                        {/*<div className="col-3"></div>*/}
          
                </div>
                </section>

                {/* Sección built for secure */} 
                {/*<section className="container pt-4">
                    <div className="row">
                        <div className="col">
                            <div className="webinarContainer mb-6 mt-2">
                                <div className="blob"></div>
                                <div className="text-center">
                                    <h3 className='fl-subtitle'>In just 20 minutes, you’ll learn:</h3>
                                    <ul className="fl-bullets text-start d-inline-block">
                                        <li>What makes AVAP Framework unique.</li>
                                        <li>How AVAP Connect works and its benefits.</li>
                                        <li>What you need to activate your participation</li>
                                    </ul>
                                    
                                     
                                <div className='btn-row'> 
                                    <a className="glowBtn-hz" 
                                    style={{zIndex: 2}} 
                                    href="https://us06web.zoom.us/webinar/register/WN_OHvLCr3-Q-2-DEEnIF9R_w#/registration" 
                                    target='_blank'>
                                        <span className="btnInner"> Register Now - ENG</span>
                                    </a> 
                                    <a className="glowBtn-hz" 
                                    style={{zIndex: 2}} 
                                    href="https://us06web.zoom.us/webinar/register/WN_DJgP8SF_SamxbVKrVMEivA#/registration" 
                                    target='_blank'>
                                        <span className="btnInner"> Register Now - ES</span>
                                    </a> 
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>*/}
            </div>
            
            

            <FlFooter></FlFooter>
        </>
    );
};

export default WebinarTimeToShare;
